export default function convertAzureIcon(iconNumber: number, isDayTime = true) {
  const dayMapping: Record<number, string> = {
    1: "mdi-weather-sunny",                // Sunny
    2: "mdi-weather-partly-cloudy",          // Mostly Sunny
    3: "mdi-weather-partly-cloudy",          // Partly Sunny
    4: "mdi-weather-cloudy",                 // Intermittent Clouds
    5: "mdi-weather-hazy",                   // Hazy Sunshine
    6: "mdi-weather-cloudy",                 // Mostly Cloudy
    7: "mdi-weather-cloudy",                 // Cloudy
    8: "mdi-weather-cloudy",                 // Dreary (Overcast)
    11: "mdi-weather-fog",                   // Fog
    12: "mdi-weather-rainy",                 // Showers
    13: "mdi-weather-rainy",                 // Mostly Cloudy with Showers
    14: "mdi-weather-rainy",                 // Partly Sunny with Showers
    15: "mdi-weather-lightning",             // Thunderstorms
    16: "mdi-weather-lightning",             // Mostly Cloudy with Thunderstorms
    17: "mdi-weather-lightning",             // Partly Sunny with Thunderstorms
    18: "mdi-weather-rainy",                 // Rain
    19: "mdi-weather-snowy",                 // Flurries
    20: "mdi-weather-snowy",                 // Mostly Cloudy with Flurries
    21: "mdi-weather-snowy",                 // Partly Sunny with Flurries
    22: "mdi-weather-snowy",                 // Snow
    23: "mdi-weather-snowy",                 // Mostly Cloudy with Snow
    24: "mdi-weather-hail",                  // Ice
    25: "mdi-weather-partly-snowy-rainy",      // Sleet
    26: "mdi-weather-rainy",                 // Freezing Rain
    29: "mdi-weather-rainy",                 // Rain and Snow
    30: "mdi-weather-sunny-alert",           // Hot
    31: "mdi-thermometer",                   // Cold
    32: "mdi-weather-windy"                  // Windy
  };

  const nightMapping: Record<number, string> = {
    33: "mdi-weather-night",                 // Clear
    34: "mdi-weather-night-partly-cloudy",     // Mostly Clear
    35: "mdi-weather-night-partly-cloudy",     // Partly Cloudy
    36: "mdi-weather-cloudy",                  // Intermittent Clouds
    37: "mdi-weather-fog",                     // Hazy Moonlight
    38: "mdi-weather-cloudy",                  // Mostly Cloudy
    39: "mdi-weather-rainy",                   // Partly Cloudy with Showers
    40: "mdi-weather-rainy",                   // Mostly Cloudy with Showers
    41: "mdi-weather-lightning",               // Partly Cloudy with Thunderstorms
    42: "mdi-weather-lightning",               // Mostly Cloudy with Thunderstorms
    43: "mdi-weather-snowy",                   // Mostly Cloudy with Flurries
    44: "mdi-weather-snowy"                    // Mostly Cloudy with Snow
  };

  if (isDayTime) {
    return dayMapping[iconNumber] || "mdi-weather-sunny";
  } else {
    // For night time, if no specific mapping exists then fall back to the day value.
    return nightMapping[iconNumber] || dayMapping[iconNumber] || "mdi-weather-night";
  }
}
